import * as types from '../types/storeTypes';
import * as storeServices from '../../services/storeServices';

export const fetchStores = () => async (dispatch) => {
  dispatch({ type: types.FETCH_STORES_REQUEST });
  try {
    const data = await storeServices.fetchStores();
    dispatch({ type: types.FETCH_STORES_SUCCESS, payload: Array.isArray(data) ? data : (data.stores || []) });
  } catch (error) {
    dispatch({ type: types.FETCH_STORES_FAILURE, payload: error.message });
  }
};

export const fetchStoreStats = () => async (dispatch) => {
  dispatch({ type: types.FETCH_STORE_STATS_REQUEST });
  try {
    const data = await storeServices.fetchStoreStats();
    dispatch({ type: types.FETCH_STORE_STATS_SUCCESS, payload: data });
  } catch (error) {
    dispatch({ type: types.FETCH_STORE_STATS_FAILURE, payload: error.message });
  }
};

export const fetchStoreGroups = () => async (dispatch) => {
  dispatch({ type: types.FETCH_STORE_GROUPS_REQUEST });
  try {
    const data = await storeServices.fetchStoreGroups();
    dispatch({ type: types.FETCH_STORE_GROUPS_SUCCESS, payload: Array.isArray(data) ? data : (data.groups || []) });
  } catch (error) {
    dispatch({ type: types.FETCH_STORE_GROUPS_FAILURE, payload: error.message });
  }
};

export const createStoreGroup = (payload) => async (dispatch) => {
  dispatch({ type: types.CREATE_STORE_GROUP_REQUEST });
  try {
    const data = await storeServices.createStoreGroup(payload);
    dispatch({ type: types.CREATE_STORE_GROUP_SUCCESS, payload: data });
    return { success: true, data };
  } catch (error) {
    dispatch({ type: types.CREATE_STORE_GROUP_FAILURE, payload: error.message });
    return { success: false, error: error.message };
  }
};

export const createStore = (payload) => async (dispatch) => {
  dispatch({ type: types.CREATE_STORE_REQUEST });
  try {
    const data = await storeServices.createStore(payload);
    dispatch({ type: types.CREATE_STORE_SUCCESS, payload: data });
    return { success: true, data };
  } catch (error) {
    dispatch({ type: types.CREATE_STORE_FAILURE, payload: error.message });
    return { success: false, error: error.message };
  }
};

export const updateStore = (id, payload) => async (dispatch) => {
  dispatch({ type: types.UPDATE_STORE_REQUEST });
  try {
    const data = await storeServices.updateStore(id, payload);
    dispatch({ type: types.UPDATE_STORE_SUCCESS, payload: data });
  } catch (error) {
    dispatch({ type: types.UPDATE_STORE_FAILURE, payload: error.message });
  }
};

export const deleteStore = (id) => async (dispatch) => {
  dispatch({ type: types.DELETE_STORE_REQUEST });
  try {
    await storeServices.deleteStore(id);
    dispatch({ type: types.DELETE_STORE_SUCCESS, payload: id });
  } catch (error) {
    dispatch({ type: types.DELETE_STORE_FAILURE, payload: error.message });
  }
};
